// src/components/molecules/FormFields/TagsInput.js
import React from "react";
import { Typography, Box } from "@mui/material";
import { WithContext as ReactTagInput } from "react-tag-input";
import { useTheme } from "styled-components";

const TagsInput = ({
  tags,
  handleTagDelete,
  handleTagAddition,
  error,
  disabled,
}) => {
  const theme = useTheme();

  return (
    <Box>
      {/* Conditionally render the Typography text only if not disabled */}
      {!disabled && (
        <Typography
          variant="body1"
          component="label"
          htmlFor="tags"
          sx={{ fontFamily: "basic-sans", color: "white", mb: 2 }}
        >
          Add tags related to your submission (press enter after each tag)
        </Typography>
      )}
      <ReactTagInput
        tags={tags}
        handleDelete={disabled ? () => {} : handleTagDelete} // Disable deletion if disabled
        handleAddition={disabled ? () => {} : handleTagAddition} // Disable addition if disabled
        placeholder={disabled ? "Tag input disabled" : "Add a tag"}
        inputFieldPosition="top"
        autocomplete
        autofocus={false}
        readOnly={disabled} // Prevent typing in the input if disabled
        classNames={{
          tag: "ReactTags__tag",
          remove: "ReactTags__remove",
          tagInput: "ReactTags__tagInput",
          tagInputField: "ReactTags__tagInputField",
        }}
      />
      {error && (
        <Typography
          variant="body2"
          sx={{
            color: theme.colors.red,
            mt: 1,
            fontFamily: "basic-sans",
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default TagsInput;
